<p-overlayPanel
  #menuPanel
  appendTo="body"
  [dismissable]="true"
  [showCloseIcon]="false"
  styleClass="custom-overlay-panel"
>
  @if (menuItems) {
    <ul class="p-menu-list p-0 m-0">
      @for (item of menuItems; track item.label) {
        <li class="p-menuitem" (click)="item.command?.({ originalEvent: $event, item: item })">
          <a class="p-menuitem-link">{{ item.label }}</a>
        </li>
      }
    </ul>
  }
</p-overlayPanel>
